import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContract  {
    _originalTypeClassName = "zERP.BO.EmployeeContract";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContract.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.MainSalaries = [];
this.BasicSalaries = [];
this.OtherSalaries = [];
this.Contributions = [];
this.Deductions = [];
this.PayrollCategoryHistory = [];
this.Documents = [];
this.SalaryPeriods = [];
this.LeaveTypes = [];
this.Id = null;
this.IsActive = false;
this.StartDate = null;
this.EndDate = null;
this.Type = null;
this.RelationshipType = null;
this.Salary = 0;
this.ContractTerminationDate = null;
this.Kind = null;
this.CompensationAmount = null;
this.AdvancePaymentAmount = null;
this.TotalPayrollPeriods = null;
this.CostCenterFrom = null;
this.CostCenterTo = null;
this.Manager = false;
this.IsSupervisor = false;
this.EligibilityStatementEnd = null;
this.EligibilityStatementStart = null;
this.EligibilityStatement = false;
this.HazardCategoryStart = null;
this.HazardCategoryEnd = null;
this.SalaryNew = null;
this.OverrideSalaryPeriodsConfig = false;
this.ProtiMeraOraProslipsis = null;
this.ProtiMeraOraApoxorisis = null;
this.UnderageCardCode = null;
this.EmploymentProperty = null;
this.EmploymentSpecialCase = null;
this.EmploymentResponsiblePosition = null;
this.E3AdditionalStaffTableCode = null;
this.E3AdditionalStaffTableDate = null;
this.E3Comments = null;
this.FlexibleArrivalInMinutes = null;
this.HasWorkingCard = false;
this.IsFirstTimeSalaried = false;
this.Comments = null;
this.CommentsMax50 = null;
this.AppointmentFEK = null;
this.AppointmentDate = null;
this.ServiceDate = null;
this.EapContractType = null;
this.PayrollCategoryHistoryStartDate = null;
this.PayrollCategoryHistoryEndDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsActive:any;
StartDate:any;
EndDate:any;
Type:any;
RelationshipType:any;
Salary:any;
ContractTerminationDate:any;
Kind:any;
CompensationAmount:any;
AdvancePaymentAmount:any;
TotalPayrollPeriods:any;
CostCenterFrom:any;
CostCenterTo:any;
Manager:any;
IsSupervisor:any;
EligibilityStatementEnd:any;
EligibilityStatementStart:any;
EligibilityStatement:any;
HazardCategoryStart:any;
HazardCategoryEnd:any;
SalaryNew:any;
OverrideSalaryPeriodsConfig:any;
ProtiMeraOraProslipsis:any;
ProtiMeraOraApoxorisis:any;
UnderageCardCode:any;
EmploymentProperty:any;
EmploymentSpecialCase:any;
EmploymentResponsiblePosition:any;
E3AdditionalStaffTableCode:any;
E3AdditionalStaffTableDate:any;
E3Comments:any;
FlexibleArrivalInMinutes:any;
HasWorkingCard:any;
IsFirstTimeSalaried:any;
Comments:any;
CommentsMax50:any;
AppointmentFEK:any;
AppointmentDate:any;
ServiceDate:any;
EapContractType:any;
PayrollCategoryHistoryStartDate:any;
PayrollCategoryHistoryEndDate:any;
Employee:any;
TerminationReason:any;
Entity:any;
Template:any;
CompensationCalculatedExpression:any;
MainSalaries:any;
BasicSalaries:any;
OtherSalaries:any;
Contributions:any;
Deductions:any;
Department:any;
Supervisor:any;
Branch:any;
AccountingConfig:any;
PayrollCategory:any;
PayrollCategoryLevel:any;
PayrollCategoryHistory:any;
Documents:any;
ProfessionSpecialization:any;
SalaryPeriods:any;
Location:any;
Floor:any;
DepartmentFloor:any;
Institution:any;
CostCenter:any;
WorkProgram:any;
HazardCategory:any;
Direction:any;
GroupEmployee:any;
ResidencePermit:any;
SepeSpecialization:any;
EmploymentStatistics:any;
WorkProgramFile:any;
CivilServantBranch:any;
CivilServantSpeciality:any;
CivilServantGrade:any;
Position:any;
ErganiDetails:any;
DypaProperties:any;
LeaveTypes:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeContracts(oldValue, $this);
}
Domain.Employee.addContracts(value, $this);
}
}
static setTerminationReason = ($this, value) => {
var oldValue = $this.TerminationReason;
$this.TerminationReason = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setTemplate = ($this, value) => {
var oldValue = $this.Template;
$this.Template = value;
if (value != null) {
}
}
static setCompensationCalculatedExpression = ($this, value) => {
var oldValue = $this.CompensationCalculatedExpression;
$this.CompensationCalculatedExpression = value;
if (value != null) {
}
}
static setMainSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.MainSalaries == null) $this.MainSalaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MainSalaries.length > 0) {
                    Domain.EmployeeContract.removeMainSalaries($this, $this.MainSalaries[0]);
                }

                Domain.EmployeeContract.addManyMainSalaries($this, copyItems);
            }
static addManyMainSalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addMainSalaries($this, items[i]);
                }
            }
static addMainSalaries = ($this, item) => {
                if ($this.MainSalaries == null) $this.MainSalaries = [];
                if (item == null || $this.MainSalaries.indexOf(item) > -1) return;
                $this.MainSalaries.push(item);
}
static addRangeMainSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addMainSalaries($this, item));
            }
static removeMainSalaries = ($this, item) => {
                if ($this == null || $this.MainSalaries == null || $this.MainSalaries.indexOf(item) === -1) return;
                var _index = $this.MainSalaries.indexOf(item);
                $this.MainSalaries.splice(_index, 1);
}
static clearMainSalaries = ($this) => { $this.MainSalaries = null; }
static setBasicSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.BasicSalaries == null) $this.BasicSalaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BasicSalaries.length > 0) {
                    Domain.EmployeeContract.removeBasicSalaries($this, $this.BasicSalaries[0]);
                }

                Domain.EmployeeContract.addManyBasicSalaries($this, copyItems);
            }
static addManyBasicSalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addBasicSalaries($this, items[i]);
                }
            }
static addBasicSalaries = ($this, item) => {
                if ($this.BasicSalaries == null) $this.BasicSalaries = [];
                if (item == null || $this.BasicSalaries.indexOf(item) > -1) return;
                $this.BasicSalaries.push(item);
}
static addRangeBasicSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addBasicSalaries($this, item));
            }
static removeBasicSalaries = ($this, item) => {
                if ($this == null || $this.BasicSalaries == null || $this.BasicSalaries.indexOf(item) === -1) return;
                var _index = $this.BasicSalaries.indexOf(item);
                $this.BasicSalaries.splice(_index, 1);
}
static clearBasicSalaries = ($this) => { $this.BasicSalaries = null; }
static setOtherSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.OtherSalaries == null) $this.OtherSalaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OtherSalaries.length > 0) {
                    Domain.EmployeeContract.removeOtherSalaries($this, $this.OtherSalaries[0]);
                }

                Domain.EmployeeContract.addManyOtherSalaries($this, copyItems);
            }
static addManyOtherSalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addOtherSalaries($this, items[i]);
                }
            }
static addOtherSalaries = ($this, item) => {
                if ($this.OtherSalaries == null) $this.OtherSalaries = [];
                if (item == null || $this.OtherSalaries.indexOf(item) > -1) return;
                $this.OtherSalaries.push(item);
}
static addRangeOtherSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addOtherSalaries($this, item));
            }
static removeOtherSalaries = ($this, item) => {
                if ($this == null || $this.OtherSalaries == null || $this.OtherSalaries.indexOf(item) === -1) return;
                var _index = $this.OtherSalaries.indexOf(item);
                $this.OtherSalaries.splice(_index, 1);
}
static clearOtherSalaries = ($this) => { $this.OtherSalaries = null; }
static setContributions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Contributions == null) $this.Contributions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Contributions.length > 0) {
                    Domain.EmployeeContract.removeContributions($this, $this.Contributions[0]);
                }

                Domain.EmployeeContract.addManyContributions($this, copyItems);
            }
static addManyContributions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addContributions($this, items[i]);
                }
            }
static addContributions = ($this, item) => {
                if ($this.Contributions == null) $this.Contributions = [];
                if (item == null || $this.Contributions.indexOf(item) > -1) return;
                $this.Contributions.push(item);
}
static addRangeContributions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addContributions($this, item));
            }
static removeContributions = ($this, item) => {
                if ($this == null || $this.Contributions == null || $this.Contributions.indexOf(item) === -1) return;
                var _index = $this.Contributions.indexOf(item);
                $this.Contributions.splice(_index, 1);
}
static clearContributions = ($this) => { $this.Contributions = null; }
static setDeductions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Deductions == null) $this.Deductions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Deductions.length > 0) {
                    Domain.EmployeeContract.removeDeductions($this, $this.Deductions[0]);
                }

                Domain.EmployeeContract.addManyDeductions($this, copyItems);
            }
static addManyDeductions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addDeductions($this, items[i]);
                }
            }
static addDeductions = ($this, item) => {
                if ($this.Deductions == null) $this.Deductions = [];
                if (item == null || $this.Deductions.indexOf(item) > -1) return;
                $this.Deductions.push(item);
}
static addRangeDeductions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addDeductions($this, item));
            }
static removeDeductions = ($this, item) => {
                if ($this == null || $this.Deductions == null || $this.Deductions.indexOf(item) === -1) return;
                var _index = $this.Deductions.indexOf(item);
                $this.Deductions.splice(_index, 1);
}
static clearDeductions = ($this) => { $this.Deductions = null; }
static setDepartment = ($this, value) => {
var oldValue = $this.Department;
$this.Department = value;
if (value != null) {
}
}
static setSupervisor = ($this, value) => {
var oldValue = $this.Supervisor;
$this.Supervisor = value;
if (value != null) {
}
}
static setBranch = ($this, value) => {
var oldValue = $this.Branch;
$this.Branch = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}
static setPayrollCategory = ($this, value) => {
var oldValue = $this.PayrollCategory;
$this.PayrollCategory = value;
if (value != null) {
}
}
static setPayrollCategoryLevel = ($this, value) => {
var oldValue = $this.PayrollCategoryLevel;
$this.PayrollCategoryLevel = value;
if (value != null) {
}
}
static setPayrollCategoryHistory = ($this, items) => {
                if (items == null) items = [];
                if ($this.PayrollCategoryHistory == null) $this.PayrollCategoryHistory = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PayrollCategoryHistory.length > 0) {
                    Domain.EmployeeContract.removePayrollCategoryHistory($this, $this.PayrollCategoryHistory[0]);
                }

                Domain.EmployeeContract.addManyPayrollCategoryHistory($this, copyItems);
            }
static addManyPayrollCategoryHistory = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addPayrollCategoryHistory($this, items[i]);
                }
            }
static addPayrollCategoryHistory = ($this, item) => {
                if ($this.PayrollCategoryHistory == null) $this.PayrollCategoryHistory = [];
                if (item == null || $this.PayrollCategoryHistory.indexOf(item) > -1) return;
                $this.PayrollCategoryHistory.push(item);
}
static addRangePayrollCategoryHistory = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addPayrollCategoryHistory($this, item));
            }
static removePayrollCategoryHistory = ($this, item) => {
                if ($this == null || $this.PayrollCategoryHistory == null || $this.PayrollCategoryHistory.indexOf(item) === -1) return;
                var _index = $this.PayrollCategoryHistory.indexOf(item);
                $this.PayrollCategoryHistory.splice(_index, 1);
}
static clearPayrollCategoryHistory = ($this) => { $this.PayrollCategoryHistory = null; }
static setDocuments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Documents == null) $this.Documents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Documents.length > 0) {
                    Domain.EmployeeContract.removeDocuments($this, $this.Documents[0]);
                }

                Domain.EmployeeContract.addManyDocuments($this, copyItems);
            }
static addManyDocuments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addDocuments($this, items[i]);
                }
            }
static addDocuments = ($this, item) => {
                if ($this.Documents == null) $this.Documents = [];
                if (item == null || $this.Documents.indexOf(item) > -1) return;
                $this.Documents.push(item);
if (item.Contract != $this) {
Domain.EmployeeDocument.setContract(item, $this);
}
}
static addRangeDocuments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addDocuments($this, item));
            }
static removeDocuments = ($this, item) => {
                if ($this == null || $this.Documents == null || $this.Documents.indexOf(item) === -1) return;
                var _index = $this.Documents.indexOf(item);
                $this.Documents.splice(_index, 1);
item.Contract = null;
}
static clearDocuments = ($this) => { $this.Documents = null; }
static setProfessionSpecialization = ($this, value) => {
var oldValue = $this.ProfessionSpecialization;
$this.ProfessionSpecialization = value;
if (value != null) {
}
}
static setSalaryPeriods = ($this, items) => {
                if (items == null) items = [];
                if ($this.SalaryPeriods == null) $this.SalaryPeriods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SalaryPeriods.length > 0) {
                    Domain.EmployeeContract.removeSalaryPeriods($this, $this.SalaryPeriods[0]);
                }

                Domain.EmployeeContract.addManySalaryPeriods($this, copyItems);
            }
static addManySalaryPeriods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addSalaryPeriods($this, items[i]);
                }
            }
static addSalaryPeriods = ($this, item) => {
                if ($this.SalaryPeriods == null) $this.SalaryPeriods = [];
                if (item == null || $this.SalaryPeriods.indexOf(item) > -1) return;
                $this.SalaryPeriods.push(item);
if (item.EmployeeContract != $this) {
Domain.EmployeeContractSalaryPeriod.setEmployeeContract(item, $this);
}
}
static addRangeSalaryPeriods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addSalaryPeriods($this, item));
            }
static removeSalaryPeriods = ($this, item) => {
                if ($this == null || $this.SalaryPeriods == null || $this.SalaryPeriods.indexOf(item) === -1) return;
                var _index = $this.SalaryPeriods.indexOf(item);
                $this.SalaryPeriods.splice(_index, 1);
item.EmployeeContract = null;
}
static clearSalaryPeriods = ($this) => { $this.SalaryPeriods = null; }
static setLocation = ($this, value) => {
var oldValue = $this.Location;
$this.Location = value;
if (value != null) {
}
}
static setFloor = ($this, value) => {
var oldValue = $this.Floor;
$this.Floor = value;
if (value != null) {
}
}
static setDepartmentFloor = ($this, value) => {
var oldValue = $this.DepartmentFloor;
$this.DepartmentFloor = value;
if (value != null) {
}
}
static setInstitution = ($this, value) => {
var oldValue = $this.Institution;
$this.Institution = value;
if (value != null) {
}
}
static setCostCenter = ($this, value) => {
var oldValue = $this.CostCenter;
$this.CostCenter = value;
if (value != null) {
}
}
static setWorkProgram = ($this, value) => {
var oldValue = $this.WorkProgram;
$this.WorkProgram = value;
if (value != null) {
}
}
static setHazardCategory = ($this, value) => {
var oldValue = $this.HazardCategory;
$this.HazardCategory = value;
if (value != null) {
}
}
static setDirection = ($this, value) => {
var oldValue = $this.Direction;
$this.Direction = value;
if (value != null) {
}
}
static setGroupEmployee = ($this, value) => {
var oldValue = $this.GroupEmployee;
$this.GroupEmployee = value;
if (value != null) {
}
}
static setResidencePermit = ($this, value) => {
var oldValue = $this.ResidencePermit;
$this.ResidencePermit = value;
if (value != null) {
}
}
static setSepeSpecialization = ($this, value) => {
var oldValue = $this.SepeSpecialization;
$this.SepeSpecialization = value;
if (value != null) {
}
}
static setEmploymentStatistics = ($this, value) => {
var oldValue = $this.EmploymentStatistics;
$this.EmploymentStatistics = value;
if (value != null) {
}
}
static setWorkProgramFile = ($this, value) => {
var oldValue = $this.WorkProgramFile;
$this.WorkProgramFile = value;
if (value != null) {
}
}
static setCivilServantBranch = ($this, value) => {
var oldValue = $this.CivilServantBranch;
$this.CivilServantBranch = value;
if (value != null) {
}
}
static setCivilServantSpeciality = ($this, value) => {
var oldValue = $this.CivilServantSpeciality;
$this.CivilServantSpeciality = value;
if (value != null) {
}
}
static setCivilServantGrade = ($this, value) => {
var oldValue = $this.CivilServantGrade;
$this.CivilServantGrade = value;
if (value != null) {
}
}
static setPosition = ($this, value) => {
var oldValue = $this.Position;
$this.Position = value;
if (value != null) {
}
}
static setErganiDetails = ($this, value) => {
var oldValue = $this.ErganiDetails;
$this.ErganiDetails = value;
if (value != null) {
}
}
static setDypaProperties = ($this, value) => {
var oldValue = $this.DypaProperties;
$this.DypaProperties = value;
if (value != null) {
}
}
static setLeaveTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.LeaveTypes == null) $this.LeaveTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LeaveTypes.length > 0) {
                    Domain.EmployeeContract.removeLeaveTypes($this, $this.LeaveTypes[0]);
                }

                Domain.EmployeeContract.addManyLeaveTypes($this, copyItems);
            }
static addManyLeaveTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeContract.addLeaveTypes($this, items[i]);
                }
            }
static addLeaveTypes = ($this, item) => {
                if ($this.LeaveTypes == null) $this.LeaveTypes = [];
                if (item == null || $this.LeaveTypes.indexOf(item) > -1) return;
                $this.LeaveTypes.push(item);
if (item.EmployeeContract != $this) {
Domain.EmployeeLeave.setEmployeeContract(item, $this);
}
}
static addRangeLeaveTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeContract.addLeaveTypes($this, item));
            }
static removeLeaveTypes = ($this, item) => {
                if ($this == null || $this.LeaveTypes == null || $this.LeaveTypes.indexOf(item) === -1) return;
                var _index = $this.LeaveTypes.indexOf(item);
                $this.LeaveTypes.splice(_index, 1);
item.EmployeeContract = null;
}
static clearLeaveTypes = ($this) => { $this.LeaveTypes = null; }

static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetHistoricCategory($this: any, payrollDate: any): any{for (let _ihEntry = 0; _ihEntry < ($this?.PayrollCategoryHistory == null ? 0 : $this?.PayrollCategoryHistory.length); _ihEntry++) {let hEntry = $this?.PayrollCategoryHistory[_ihEntry];if ((new Date(new Date(new Date(hEntry?.StartDate)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(new Date(new Date(payrollDate)?.setHours(0, 0, 0, 0))).getTime()) && (new Date(new Date(new Date(hEntry?.EndDate)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(new Date(new Date(payrollDate)?.setHours(0, 0, 0, 0))).getTime())) {return hEntry?.PayrollCategory;}}
return $this?.PayrollCategory;
}
static GetHistoricCategoryLevel($this: any, payrollDate: any): any{for (let _ihEntry = 0; _ihEntry < ($this?.PayrollCategoryHistory == null ? 0 : $this?.PayrollCategoryHistory.length); _ihEntry++) {let hEntry = $this?.PayrollCategoryHistory[_ihEntry];if ((new Date(new Date(new Date(hEntry?.StartDate)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(new Date(new Date(payrollDate)?.setHours(0, 0, 0, 0))).getTime()) && (new Date(new Date(new Date(hEntry?.EndDate)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(new Date(new Date(payrollDate)?.setHours(0, 0, 0, 0))).getTime())) {return hEntry?.Level;}}
return $this?.PayrollCategoryLevel?.Level;
}
static GetWorkExperienceInYears($this: any, includePastExperience: any): any{let currentExpirienceInDays = Joove.Common.cast(Math.abs(Joove.Common.dateDiff(moment().toDate(), $this?.StartDate)?.days), "number");
let currentExpirienceInYears = Math.floor(Joove.Common.safeNumber(currentExpirienceInDays) / Joove.Common.safeNumber(356));
return Joove.Common.safeNumber(((includePastExperience ? $this?.Employee?.WorkExperienceAnalysis?.ExperienceInYears : 0))) + Joove.Common.safeNumber(Joove.Common.cast(currentExpirienceInYears, "number"));
}
static IsActiveInPeriod($this: any, from: any,to: any): any{return (new Date(new Date(new Date($this?.StartDate)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(to).getTime()) && (Domain.DateHelper.IsDateNull($this?.EndDate) || (new Date(new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(from).getTime()));
}
static ParseEligibilityStatement(el: any): any{return (el == "ΝΑΙ" ? true : false);
}
static ParseIsActive(el: any): any{return (el == "ΝΑΙ" ? true : false);
}
static ParseIsSupervisor(el: any): any{return (el == "ΝΑΙ" ? true : false);
}
static ParseKind(el: any): any{return (el == "Μόνιμος" ? Domain.EmploymentKind.Permanent : ((el == "Ορισμένου χρόνου" ? Domain.EmploymentKind.FixedTerm : ((el == "Κατά Έργο" ? Domain.EmploymentKind.ByProject : ((el == "Υπερσυμβόλαιο" ? Domain.EmploymentKind.SubContract : ((el == "Πρακτική" ? Domain.EmploymentKind.Internship : ((el == "Ασκούμενος" ? Domain.EmploymentKind.Trainee : ((el == "ΙΔΑΧ" ? Domain.EmploymentKind.IDAX : ((el == "ΙΔΟΧ" ? Domain.EmploymentKind.IDOX : Domain.EmploymentKind.Installed)))))))))))))));
}
static ParseManager(el: any): any{return (el == "ΝΑΙ" ? true : false);
}
static ParseRelationType(el: any): any{return (el == "Μισθωτός" ? Domain.EmploymentRelationshipType.Salaried : ((el == "Ημερομίσθιος" ? Domain.EmploymentRelationshipType.DailySalaried : ((el == "Ωρομίσθιο" ? Domain.EmploymentRelationshipType.HourlySalaried : ((el == "Αυτοαπασχολούμενος" ? Domain.EmploymentRelationshipType.SelfEmployment : ((el == "Απόδειξη Εξόδων" ? Domain.EmploymentRelationshipType.ReceiptOfExpense : ((el == "Διαχείριση" ? Domain.EmploymentRelationshipType.Management : ((el == "Πρακτική" ? Domain.EmploymentRelationshipType.Internship : Domain.EmploymentRelationshipType.Trainee)))))))))))));
}
static ParseType(el: any): any{return (el == "Πλήρης απασχόληση" ? Domain.EmploymentType.FullTime : ((el == "Μερικής απασχόλησης" ? Domain.EmploymentType.PartTime : ((el == "Διαλείπουσα" ? Domain.EmploymentType.Intermitting : ((el == "Με εκ περιτροπής" ? Domain.EmploymentType.ByRotation : ((el == "Διευθυντής" ? Domain.EmploymentType.Director : Domain.EmploymentType.Internship)))))))));
}
static returnEmploymentKindGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Μόνιμος" : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? "Ορισμένου χρόνου" : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? "Κατά Έργο" : ((CLMS.Framework.Number.Equal(() => index, () => 3) ? "Υπερσυμβόλαιο" : ((CLMS.Framework.Number.Equal(() => index, () => 4) ? "Πρακτική" : ((CLMS.Framework.Number.Equal(() => index, () => 5) ? "Ασκούμενος" : ((CLMS.Framework.Number.Equal(() => index, () => 6) ? "ΙΔΑΧ" : ((CLMS.Framework.Number.Equal(() => index, () => 7) ? "ΙΔΟΧ" : "Εγκατεστημένο")))))))))))))));
}
static returnEmploymentKindIndex(ek: any): any{return (ek == Domain.EmploymentKind.Permanent ? 0 : ((ek == Domain.EmploymentKind.FixedTerm ? 1 : ((ek == Domain.EmploymentKind.ByProject ? 2 : ((ek == Domain.EmploymentKind.SubContract ? 3 : ((ek == Domain.EmploymentKind.Internship ? 4 : ((ek == Domain.EmploymentKind.Trainee ? 5 : ((ek == Domain.EmploymentKind.IDAX ? 6 : ((ek == Domain.EmploymentKind.IDOX ? 7 : 8)))))))))))))));
}
static returnEmploymentKindValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? Domain.EmploymentKind.Permanent : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? Domain.EmploymentKind.FixedTerm : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? Domain.EmploymentKind.ByProject : ((CLMS.Framework.Number.Equal(() => index, () => 3) ? Domain.EmploymentKind.SubContract : ((CLMS.Framework.Number.Equal(() => index, () => 4) ? Domain.EmploymentKind.Internship : ((CLMS.Framework.Number.Equal(() => index, () => 5) ? Domain.EmploymentKind.Trainee : ((CLMS.Framework.Number.Equal(() => index, () => 6) ? Domain.EmploymentKind.IDAX : ((CLMS.Framework.Number.Equal(() => index, () => 7) ? Domain.EmploymentKind.IDOX : Domain.EmploymentKind.Installed)))))))))))))));
}
static returnEmploymentRelationshipTypeGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Μισθωτός" : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? "Ημερομίσθιος" : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? "Ωρομίσθιο" : ((CLMS.Framework.Number.Equal(() => index, () => 3) ? "Αυτοαπασχολούμενος" : ((CLMS.Framework.Number.Equal(() => index, () => 4) ? "Απόδειξη Εξόδων" : ((CLMS.Framework.Number.Equal(() => index, () => 5) ? "Διαχείριση" : ((CLMS.Framework.Number.Equal(() => index, () => 6) ? "Πρακτική" : "Ασκούμενος")))))))))))));
}
static returnEmploymentRelationshipTypeIndex(er: any): any{return (er == Domain.EmploymentRelationshipType.Salaried ? 0 : ((er == Domain.EmploymentRelationshipType.DailySalaried ? 1 : ((er == Domain.EmploymentRelationshipType.HourlySalaried ? 2 : ((er == Domain.EmploymentRelationshipType.SelfEmployment ? 3 : ((er == Domain.EmploymentRelationshipType.ReceiptOfExpense ? 4 : ((er == Domain.EmploymentRelationshipType.Management ? 5 : ((er == Domain.EmploymentRelationshipType.Internship ? 6 : 7)))))))))))));
}
static returnEmploymentRelationshipTypeValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? Domain.EmploymentRelationshipType.Salaried : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? Domain.EmploymentRelationshipType.DailySalaried : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? Domain.EmploymentRelationshipType.HourlySalaried : ((CLMS.Framework.Number.Equal(() => index, () => 3) ? Domain.EmploymentRelationshipType.SelfEmployment : ((CLMS.Framework.Number.Equal(() => index, () => 4) ? Domain.EmploymentRelationshipType.ReceiptOfExpense : ((CLMS.Framework.Number.Equal(() => index, () => 5) ? Domain.EmploymentRelationshipType.Management : ((CLMS.Framework.Number.Equal(() => index, () => 6) ? Domain.EmploymentRelationshipType.Internship : Domain.EmploymentRelationshipType.Trainee)))))))))))));
}
static returnEmploymentTypeGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Πλήρης απασχόληση" : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? "Μερικής απασχόλησης" : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? "Διαλείπουσα" : ((CLMS.Framework.Number.Equal(() => index, () => 3) ? "Με εκ περιτροπής" : ((CLMS.Framework.Number.Equal(() => index, () => 4) ? "Διευθυντής" : "Πρακτική Άσκηση")))))))));
}
static returnEmploymentTypeIndex(et: any): any{return (et == Domain.EmploymentType.FullTime ? 0 : ((et == Domain.EmploymentType.PartTime ? 1 : ((et == Domain.EmploymentType.Intermitting ? 2 : ((et == Domain.EmploymentType.ByRotation ? 3 : ((et == Domain.EmploymentType.Director ? 4 : 5)))))))));
}
static returnEmploymentTypeValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? Domain.EmploymentType.FullTime : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? Domain.EmploymentType.PartTime : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? Domain.EmploymentType.Intermitting : ((CLMS.Framework.Number.Equal(() => index, () => 3) ? Domain.EmploymentType.ByRotation : ((CLMS.Framework.Number.Equal(() => index, () => 4) ? Domain.EmploymentType.Director : Domain.EmploymentType.Internship)))))))));
}
static Terminate($this: any, reason: any,date: any): any{Domain.EmployeeContract.setTerminationReason($this, reason);
$this.ContractTerminationDate = date;
if ((new Date(date).getTime()) < (new Date(moment().toDate()).getTime())) {$this.IsActive = false;}
}
static UndoTermination($this: any): any{Domain.EmployeeContract.setTerminationReason($this, null);
$this.ContractTerminationDate = null;
$this.IsActive = true;
}
static UpdateTotalPeriods($this: any): any{let total = 0.0;
for (let _iperiod = 0; _iperiod < ($this?.SalaryPeriods == null ? 0 : $this?.SalaryPeriods.length); _iperiod++) {let period = $this?.SalaryPeriods[_iperiod];if (period?.SalaryPeriod?.SystemType == Domain.SystemSalaryPeriod.Basic) {total = Joove.Common.safeNumber(total) + Joove.Common.safeNumber(period?.Weight) * Joove.Common.safeNumber(12);}else {total = Joove.Common.safeNumber(total) + Joove.Common.safeNumber(period?.Weight);}}
$this.TotalPayrollPeriods = total;
}
static ValidateDateOverlap($this: any): any{let messageForSalaries = "You cannot add this pay type for the selected period because it overlaps with an existing entry. Please adjust the start and end dates.";
let messageForDeductions = "You cannot add this Deduction for the selected period because it overlaps with an existing entry. Please adjust the start and end dates.";
let orderBasics = $this?.BasicSalaries?.linq?.orderBy((l) => l?.Rule?.Id)?.toArray()?.linq?.orderBy((k) => k?.DateFrom)?.toArray();
for (let _ibSalary = 0; _ibSalary < (orderBasics == null ? 0 : orderBasics.length); _ibSalary++) {let bSalary = orderBasics[_ibSalary];if ((new Date(bSalary?.DateFrom).getTime()) > (new Date(bSalary?.DateTo).getTime()) && !(Domain.DateHelper.IsDateNull(bSalary?.DateTo))) {console.error("bSalary.DateFrom >= bSalary.DateTo");return messageForSalaries;}let salaryIndex = orderBasics?.indexOf(bSalary);let nextSalary = null;if (CLMS.Framework.Number.LessThan(() => salaryIndex, () => Joove.Common.safeNumber(orderBasics.length) - Joove.Common.safeNumber(1))) {nextSalary = orderBasics[Joove.Common.safeNumber(salaryIndex) + Joove.Common.safeNumber(1)];}else {continue;}if (CLMS.Framework.Number.GreaterThan(() => orderBasics.linq.where((b) => CLMS.Framework.Number.Equal(() => b.Rule.Id, () => bSalary.Rule.Id)).toArray().length, () => 1) && CLMS.Framework.Number.Equal(() => bSalary.Rule.Id, () => nextSalary.Rule.Id)) {if ((new Date(nextSalary?.DateFrom).getTime()) <= (new Date(bSalary?.DateTo).getTime())) {console.error("nextSalary.DateFrom <= bSalary.DateTo");return messageForSalaries;}else if ((new Date(nextSalary?.DateFrom).getTime()) >= (new Date(nextSalary?.DateTo).getTime()) && !(Domain.DateHelper.IsDateNull(nextSalary?.DateTo))) {console.error("nextSalary.DateFrom >= nextSalary.DateTo");return messageForSalaries;}}}
let orderMains = $this?.MainSalaries?.linq?.orderBy((l) => l?.Rule?.Id)?.toArray()?.linq?.orderBy((k) => k?.DateFrom)?.toArray();
for (let _imSalary = 0; _imSalary < (orderMains == null ? 0 : orderMains.length); _imSalary++) {let mSalary = orderMains[_imSalary];if ((new Date(mSalary?.DateFrom).getTime()) >= (new Date(mSalary?.DateTo).getTime()) && !(Domain.DateHelper.IsDateNull(mSalary?.DateTo))) {console.error("mSalary.DateFrom >= mSalary.DateTo");return messageForSalaries;}let salaryIndex = orderMains?.indexOf(mSalary);let nextSalary = null;if (CLMS.Framework.Number.LessThan(() => salaryIndex, () => Joove.Common.safeNumber(orderMains.length) - Joove.Common.safeNumber(1))) {nextSalary = orderMains[Joove.Common.safeNumber(salaryIndex) + Joove.Common.safeNumber(1)];}else {break;}if (CLMS.Framework.Number.GreaterThan(() => orderMains.linq.where((b) => CLMS.Framework.Number.Equal(() => b.Rule.Id, () => mSalary.Rule.Id)).toArray().length, () => 1) && CLMS.Framework.Number.Equal(() => mSalary.Rule.Id, () => nextSalary.Rule.Id)) {if ((new Date(nextSalary?.DateFrom).getTime()) <= (new Date(mSalary?.DateTo).getTime())) {console.error("nextSalary.DateFrom <= mSalary.DateTo");return messageForSalaries;}else if ((new Date(nextSalary?.DateFrom).getTime()) >= (new Date(nextSalary?.DateTo).getTime()) && !(Domain.DateHelper.IsDateNull(nextSalary?.DateTo))) {console.error("nextSalary.DateFrom >= nextSalary.DateTo");return messageForSalaries;}}}
let orderOthers = $this?.OtherSalaries?.linq?.orderBy((l) => l?.Rule?.Id)?.toArray()?.linq?.orderBy((k) => k?.DateFrom)?.toArray();
for (let _ioSalary = 0; _ioSalary < (orderOthers == null ? 0 : orderOthers.length); _ioSalary++) {let oSalary = orderOthers[_ioSalary];if ((new Date(oSalary?.DateFrom).getTime()) >= (new Date(oSalary?.DateTo).getTime()) && !(Domain.DateHelper.IsDateNull(oSalary?.DateTo))) {console.error("oSalary.DateFrom >= oSalary.DateTo");return messageForSalaries;}let salaryIndex = orderOthers?.indexOf(oSalary);let nextSalary = null;if (CLMS.Framework.Number.LessThan(() => salaryIndex, () => Joove.Common.safeNumber(orderOthers.length) - Joove.Common.safeNumber(1))) {nextSalary = orderOthers[Joove.Common.safeNumber(salaryIndex) + Joove.Common.safeNumber(1)];}else {break;}if (CLMS.Framework.Number.GreaterThan(() => orderOthers.linq.where((b) => CLMS.Framework.Number.Equal(() => b.Rule.Id, () => oSalary.Rule.Id)).toArray().length, () => 1) && CLMS.Framework.Number.Equal(() => oSalary.Rule.Id, () => nextSalary.Rule.Id)) {if ((new Date(nextSalary?.DateFrom).getTime()) <= (new Date(oSalary?.DateTo).getTime())) {console.error("nextSalary.DateFrom <= oSalary.DateTo");return messageForSalaries;}else if ((new Date(nextSalary?.DateFrom).getTime()) >= (new Date(nextSalary?.DateTo).getTime()) && !(Domain.DateHelper.IsDateNull(nextSalary?.DateTo))) {console.error("nextSalary.DateFrom >= nextSalary.DateTo");return messageForSalaries;}}}
let orderDeductions = $this?.Deductions?.linq?.orderBy((l) => l?.Rule?.Id)?.toArray()?.linq?.orderBy((k) => k?.DateFrom)?.toArray();
for (let _ided = 0; _ided < (orderDeductions == null ? 0 : orderDeductions.length); _ided++) {let ded = orderDeductions[_ided];if ((new Date(ded?.DateFrom).getTime()) >= (new Date(ded?.DateTo).getTime()) && !(Domain.DateHelper.IsDateNull(ded?.DateTo))) {console.error("ded.DateFrom >= ded.DateTo");return messageForDeductions;}let deductionIndex = orderDeductions?.indexOf(ded);let nextDeduction = null;if (CLMS.Framework.Number.LessThan(() => deductionIndex, () => Joove.Common.safeNumber(orderDeductions.length) - Joove.Common.safeNumber(1))) {nextDeduction = orderDeductions[Joove.Common.safeNumber(deductionIndex) + Joove.Common.safeNumber(1)];}else {break;}if (CLMS.Framework.Number.GreaterThan(() => orderDeductions.linq.where((b) => CLMS.Framework.Number.Equal(() => b.Rule.Id, () => ded.Rule.Id)).toArray().length, () => 1) && CLMS.Framework.Number.Equal(() => ded.Rule.Id, () => nextDeduction.Rule.Id)) {if ((new Date(nextDeduction?.DateFrom).getTime()) <= (new Date(ded?.DateTo).getTime())) {console.error("nextDeduction.DateFrom <= ded.DateTo");return messageForDeductions;}else if ((new Date(nextDeduction?.DateFrom).getTime()) >= (new Date(nextDeduction?.DateTo).getTime()) && !(Domain.DateHelper.IsDateNull(nextDeduction?.DateTo))) {console.error("nextDeduction.DateFrom >= nextDeduction.DateTo");return messageForDeductions;}}}
return null;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}